import * as React from "react"

const SvgLock = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 22.714q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20.714v-10q0-.825.588-1.412A1.93 1.93 0 0 1 6 8.714h1v-2Q7 4.64 8.463 3.177 9.925 1.714 12 1.714c2.075 0 2.563.488 3.537 1.463Q17 4.639 17 6.714v2h1q.824 0 1.413.588.587.587.587 1.412v10a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-2h12v-10H6zm6-3q.825 0 1.412-.587.588-.588.588-1.413c0-.825-.196-1.02-.588-1.412A1.93 1.93 0 0 0 12 13.714q-.825 0-1.412.588A1.93 1.93 0 0 0 10 15.714q0 .825.588 1.413.587.587 1.412.587m-3-9h6v-2q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 3.714q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 6.714z" />
  </svg>
)
export default SvgLock
